import { render, staticRenderFns } from "./MembershipBenefitTable.vue?vue&type=template&id=34c253c4&scoped=true"
import script from "./MembershipBenefitTable.vue?vue&type=script&lang=js"
export * from "./MembershipBenefitTable.vue?vue&type=script&lang=js"
import style0 from "./MembershipBenefitTable.vue?vue&type=style&index=0&id=34c253c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c253c4",
  null
  
)

export default component.exports